import { render, staticRenderFns } from "./TimetableViewSettings.vue?vue&type=template&id=53fd4dee"
import script from "./TimetableViewSettings.vue?vue&type=script&lang=js"
export * from "./TimetableViewSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports